import * as React from 'react'

import { ConnectedRouter } from 'connected-react-router'

import { AccountType }      from './api'
import { NotAuthenticated } from './components/environments'
import { AppToast }         from './components/organisms'
import { credentials }      from './project-utils/credentials-cookie'
import logout               from './project-utils/hard-logout'
import { isInMentoring }    from './project-utils/permissions'
import { history }          from './redux'
import {
  BLCCoachingRoutingConfig,
  BLCMentoringRoutingConfig,
  CoacheeRoutingConfig,
  CoachRoutingConfig,
  CompanyRoutingConfig,
  MenteeRoutingConfig,
  MentorRoutingConfig,
}                           from './routing'

const Main: React.SFC<{}> = () => {
  const { type, token } = credentials

  const host = window.location.hostname

  if (type) {
    if (
      host.includes('mentoring')
      && !isInMentoring(type)
    ) {
      logout()
      window.location.href = 'https://' + host.replace('mentoring', 'coaching')
      return null
    }

    if (
      host.includes('coaching')
      && isInMentoring(type)
    ) {
      logout()
      window.location.href = 'https://' + host.replace('coaching', 'mentoring')
      return null
    }
  }

  let routing
  /*
   being logged in means having an associated type and token.
   if for either that is not the case for whatever reason (
   simply not logged in or some 'Hackerman' deleted random
   entries from cookies
   ) we show them the LoginArea

   this is by-passable by setting a truthy value on both properties
   'type' and 'token' in the cached state.auth but we don't care
   about that too much because it doesn't expose webservice-data
   */
  if (!type || !token) {
    routing = <NotAuthenticated />
  } else {
    switch (type) {
      case AccountType.CompanyCoaching:
        routing = <CompanyRoutingConfig />
        break

      case AccountType.CompanyMentoring:
        routing = <CompanyRoutingConfig />
        break

      case AccountType.Mentee:
        routing = <MenteeRoutingConfig />
        break

      case AccountType.Mentor:
        routing = <MentorRoutingConfig />
        break

      case AccountType.BlcMentoring:
        routing = <BLCMentoringRoutingConfig />
        break

      case AccountType.Coachee:
        routing = <CoacheeRoutingConfig />
        break

      case AccountType.Coach:
        routing = <CoachRoutingConfig />
        break

      case AccountType.BlcCoaching:
        routing = <BLCCoachingRoutingConfig />
        break
        
      case AccountType.Admin:
        routing = <CompanyRoutingConfig />
        break
      /*
       the only two ways this default can be hit (afaik) is if the user
       we're to manually set a url-encoded cookie containing an unknown
       role property or if the user inspects the app with react-devtools
       and changes the type state of the Authentication Component manually
       to an unknown value
       */
      default:
        console.log('no route found')
        return null
    }
  }

  /*
   this is a workaround to the problem of redux being blind to context
   we're keeping the location state in the redux store and this component
   knows about it and will trigger a re-render whenever it changes
   */
  return (
    <ConnectedRouter history={history}>
      <>
        {routing}
        <AppToast />
      </>
    </ConnectedRouter>
  )
}

export default Main



// WEBPACK FOOTER //
// ./src/Main.tsx